<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-fieldusage-checkbox">
  <!-- Checkbox fields do not have the ability to be inline edited, so they are directly accessed via their value: -->
    <ul>
      <li>
        <code>checkbox</code> is {{ checkbox1Value }}
      </li>
      <li>
        <code>checkbox2</code> is {{ checkbox2Value }}
      </li>
    </ul>
</app-styleguide-specimen>
